/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Types } from 'bridge-commands/types';

export import ApplicationLifetimeEventType = Types.Common.Applicationinfo.ApplicationLifetimeEventType;

export import NativeShutdownReason = Types.Common.Applicationinfo.ShutdownReason;

export enum UIShutdownReason {
    ApplicationRequestedExit = 'APPLICATION_REQUESTED_EXIT',
    IpcRequestedExit = 'IPC_REQUESTED_EXIT'
}

export type ShutdownReason = UIShutdownReason | NativeShutdownReason;

export interface RegisteredWorkHandle {
    remove();
}
